/**
 * fetchSuggestions — REST call for the empty-state suggestion chips.
 *
 * Extracted from App.tsx so it has the same throw-on-failure contract as
 * fetchConversations: the loadingWorkspace boot phase runs both in a
 * Promise.all and needs to distinguish "fetch failed" from "fetch
 * succeeded with zero suggestions." A failure here is still non-fatal to
 * boot overall (no suggestion chips is an acceptable degraded state) —
 * the caller decides how to handle the rejection, this function just
 * stops swallowing it silently.
 */
import { authService } from './auth';
import { API_URL } from './common/constants';
import { fetchJson } from './fetchJson';

/** Fetch suggested prompts. Throws if there's no valid token or the request fails. */
export async function fetchSuggestions(): Promise<string[]> {
  const data = await fetchJson<{ questions?: string[] }>(
    `${API_URL}/suggestions`,
    authService.getIdToken(),
    'suggestions',
  );
  return data?.questions?.length ? data.questions : [];
}
